'use client';

import { createContext, type PropsWithChildren, useContext } from 'react';

export function createPageInstanceId(pageId: string, instanceId: string): string {
  return `page_instance:${pageId}:${instanceId}`;
}

export function getInterfacePageFromPageInstanceId(instanceId: string): string {
  return instanceId.split(':')[1];
}

/**
 * when undefined -> main page (direct store keys).
 * when string -> page instance key (e.g. page_instance:{pageId}:{instanceId}); read/write from store.instances[instanceId].
 */
const PageInstanceIdContext = createContext<string | undefined>(undefined);

export function PageInstanceIdProvider({
  value,
  children,
}: PropsWithChildren<{ value: string | undefined }>) {
  return <PageInstanceIdContext.Provider value={value}>{children}</PageInstanceIdContext.Provider>;
}

export function ResetPageInstanceIdProvider({ children }: PropsWithChildren) {
  return (
    <PageInstanceIdContext.Provider value={undefined}>{children}</PageInstanceIdContext.Provider>
  );
}

export function usePageInstanceId(): string | undefined {
  const instanceId = useContext(PageInstanceIdContext);
  return instanceId;
}
